<template>
  <div
    class="breadcrumb container-xl mx-3 mt-3"
    style="background-color: white"
  >
    <ul>
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        :class="'linked'"
        @click="routeTo(idx)"
      >
        {{
          idx === breadcrumbList.length - 1
            ? label
              ? label
              : breadcrumb.text
            : breadcrumb.text
        }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

defineOptions({ name: "Breadcrumb" });

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  breadcrumbOverride: {
    type: Array,
    default: () => [],
  },
});

const router = useRouter();
const route = useRoute();
const breadcrumbList = ref([]);

const updateList = () => {
  if (props.breadcrumbOverride && props.breadcrumbOverride.length > 0) {
    breadcrumbList.value = props.breadcrumbOverride;
    return;
  }
  breadcrumbList.value = route.meta?.breadCrumbs || [];
};

const routeTo = (index) => {
  const target = breadcrumbList.value[index];
  if (target && target.to) {
    router.push(target.to);
  }
};

updateList();

watch(
  () => route.fullPath,
  () => updateList()
);

watch(
  () => props.breadcrumbOverride,
  () => updateList(),
  { deep: true }
);
</script>

<style scoped>
@media (min-width: 768px) {
  ul {
    display: flex;
    justify-content: center;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  ul > li {
    display: flex;
    float: left;
    height: 10px;
    width: auto;
    color: $default;
    font-weight: bold;
    font-size: 1em;
    cursor: default;
    align-items: center;
  }
  ul > li:not(:last-child)::after {
    content: "/";
    float: right;
    font-size: 1em;
    margin: 0 0.5em;
    color: $light-default;
    cursor: default;
  }
  .linked {
    cursor: pointer;
    font-size: 1em;
    font-weight: normal;
  }
}
@media (max-width: 767px) {
  ul {
    display: flex;
    justify-content: center;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  ul > li {
    display: flex;
    float: left;
    height: 10px;
    width: auto;
    color: $default;
    font-weight: bold;
    font-size: 1em;
    cursor: default;
    align-items: center;
  }
  ul > li:not(:last-child) {
    display: none;
  }
  .linked {
    cursor: pointer;
    font-size: 1em;
    font-weight: normal;
  }
}
</style>
